import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-faq',
  templateUrl: './portal-faq.component.html',
  styleUrls: ['./portal-faq.component.css']
})
export class PortalFaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
